import React from 'react'
import styled from 'styled-components'
import RemarkModal from '../../arizot/View/RemarkModal'
import { IRemarkData } from '../../arizot/View/ArizotViewMain'

type Props = {
  data: IRemarkData,
  close: () => void,
  isActive?: boolean,
  handleSave?: (input: string) => void
}
const RemarkOrderModal = ({ close, data, isActive, handleSave}: Props) => {
  
  return (
    <MainWrapper>
        <RemarkModal 
            close={close}
            data={data}
            isActive={isActive}
            handleSave={handleSave}
        />
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
    width: 100%;
    height: 100%;
`
export default RemarkOrderModal